module.exports = __webpack_public_path__ + "static/quote@2x-947b11410d2f7cf4180f0891142d1b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cookpad/quote@2x.jpg
// module id = 351
// module chunks = 3627797113349 20562973939449 33019919093843